import React from 'react';
import styles from './Card.module.sass';

const Card = (props) => {
    return (
        <div
          className={[styles.Card, props.className, "ga-eventos"].join(' ')}>
            {props.showHeader ? <div className={styles.cardHeader}/> : null }
            <div className={styles.content}>{props.children}</div>

        </div>
    );
};

export default Card;
